import angular from 'angular';

import NewsService from './news_service';
import EventsService from './events_service';
import OfficesService from './offices_service';
import AppsService from './apps_service';
import UsersService from './users_service';
import CryptService from './crypt_service';
import SeldaAPIService from './selda_api_service';

// application services
export default angular
  .module('app.services', [])
  .service({
    NewsService,
    EventsService,
    OfficesService,
    AppsService,
    UsersService,
    CryptService,
    SeldaAPIService
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/services/services.js